"use strict";

import React, {useState, useEffect} from 'react';
import Order from "../../order/component/Order";
import orderAddress from "../../order/utilities/orderAddress";
import axios from "../../axiosWrapper";


const OrderLookupContainer = (props) => {
    const {
              match             = {},
              isTopsOrder       = false,
          }                                     = props;
    const [order, setOrder]                     = useState({});
    const [orderShipments, setOrderShipments]   = useState([]);
    const [billingAddress, setBillingAddress]   = useState({});
    const [shippingAddress, setShippingAddress] = useState({});
    const [lineItems, setLineItems]             = useState([]);
    const [sampleLineItems, setSampleLineItems] = useState([]);

    useEffect(
        () => {
            const id    = match.params.id;
            const email = match.params.email;
            window.scrollTo(0, 0);
            fetchOrderInfo(id, isTopsOrder, email);
            fetchShipments(id, isTopsOrder, email)
        },
        []
    );

    useEffect(
        () => {
            setBillingAddress(orderAddress(order, 'billing'));
            setShippingAddress(orderAddress(order, 'shipping'));
        },
        [order]
    );

    useEffect(
        () => {
            fetchLineItems(match.params.id, isTopsOrder, match.params.email);
        },
        []
    );

    function fetchOrderInfo(id = 0, isTopsOrder = false, email = '') {
        const url = `/order-lookup${isTopsOrder ? '/webTops' : ''}/orders/${id}`;
        axios.get(url, {params: {email: email}})
             .then(function (response) {
                 setOrder((prevState) => {
                     return response.data;
                 });
             }.bind(this))
             .catch(function (error) {
                 return false;
             }.bind(this));
    }

    function fetchLineItems(id = 0, isTopsOrder = false, email = '') {
        const url               = `/order-lookup${isTopsOrder ? '/webTops' : ''}/orders/${id}/line-items`;
        const cancelToken       = axios.CancelToken;
        const axiosCancelSource = cancelToken.source();
        axios.get(url,
            {
                cancelToken: axiosCancelSource.token,
                params:      {email: email},
            })
             .then(function (response) {
                 setLineItems((prevState) => {
                     return filterLineItems(response.data, 0);
                 });
                 setSampleLineItems((prevState) => {
                     return filterLineItems(response.data, 1);
                 });
             }.bind(this))
             .catch(function (error) {
                 if (axios.isCancel(error)) {
                     //
                 } else {
                     //
                 }
             }.bind(this));
    }

    function fetchShipments(id = 0, isTopsOrder = false, email = '') {
        if (isTopsOrder) {
            const url               = `/order-lookup/webTops/orders/${id}/shipping-results`;
            const cancelToken       = axios.CancelToken;
            const axiosCancelSource = cancelToken.source();
            axios.get(url,
                {
                    cancelToken: axiosCancelSource.token,
                    params: {email: email},
                }).then(function (response) {
                //console.log(response.data);
                setOrderShipments(response.data);
            }.bind(this))
                 .catch(function (error) {
                     if (axios.isCancel(error)) {
                         //
                     } else {
                         //
                     }
                 }.bind(this));
        }
    }

    function filterLineItems(lineItems, sample) {
        if (!!lineItems && lineItems.length)
            return lineItems.filter((item) => {
                return item.sample === sample
            });
        else
            return [];
    }

    return (<Order isTopsOrder={isTopsOrder}
                   order={order}
                   billingAddress={billingAddress}
                   shippingAddress={shippingAddress}
                   lineItems={lineItems}
                   sampleItems={sampleLineItems}
                   shipments={orderShipments}/>);
};

export default OrderLookupContainer;